export const allWidgets = [
  {
    id: "jiraThroughput",
    title: "CloudOps Throughput",
    description: "Team capacity and ticket completion rates",
  },
  { id: "vulnerabilities", title: "Vulnerabilities", description: "Vulnerabilities in the system" },
  { id: "vendorSpend", title: "Vendor Spend", description: "Spend by vendor" },
  { id: "ec2ByOs", title: "EC2 by OS", description: "EC2 instances by OS" },
  { id: "datadogHeatMap", title: "Datadog Heatmap", description: "Datadog heatmap" },
  { id: "jiraTrend", title: "Jira Trend", description: "Jira trend" },
];

export const DEFAULT_WIDGETS = [
  { id: "jiraThroughput", hasInsights: true, promptKey: "jiraThroughput" },
  { id: "vendorSpend", hasInsights: true, promptKey: "vendorSpend" },
  { id: "vulnerabilities", hasInsights: true, promptKey: "vulnerabilities" },
  { id: "ec2ByOs", hasInsights: true, promptKey: "ec2ByOs" },
  { id: "datadogHeatMap", hasInsights: false, promptKey: "datadogHeatMap" },
];

export const DEFAULT_LAYOUT = [
  { i: "vendorSpend", x: 0, y: 0, w: 6, rowSpan: 1 },
  { i: "vulnerabilities", x: 6, y: 0, w: 6, rowSpan: 1 },
  { i: "jiraThroughput", x: 0, y: 1, w: 5, rowSpan: 1 },
  { i: "ec2ByOs", x: 5, y: 1, w: 4, rowSpan: 1 },
  { i: "datadogHeatMap", x: 9, y: 1, w: 3, rowSpan: 1 },
];
